/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkflowStep { 
    /**
     * The internal identifier that uniquely references a step
     */
    id: string;
    /**
     * The name of the step
     */
    name?: string;
    /**
     * The start time of the step
     */
    startTime?: Date;
    /**
     * The end time of the step
     */
    endTime?: Date;
}
